import { DeliverySectionHeader } from "./DeliverySectionHeader";

export { DeliverySectionHeaderVariant } from "./DeliverySectionHeader";
export default DeliverySectionHeader;
